import React, { Component } from 'react'
import styles from './styles.scss'

import Cover from 'src/components/cover-img'

import components from 'src/utils/components'

export default class ColumnVideo extends Component {
  constructor(props) {
    super(props)

    this.key = `${this.props.type}-${Math.random()}`
  }

  onClick = () => {
    components.allComponents.worldPlayer.animateIn(this.props.idYt)
  }

  render() {
    return (
      <div ref="component" className="component column-video">
        <div className="wrapper-content">
          <div
            onClick={this.onClick}
            ref="playerContainer"
            className="player-container">
            <img
              ref="play"
              className="play"
              src={`${process.env.PUBLIC_URL}/img/player/play.png`}
            />
            <img
              className="img-player"
              src={`${process.env.PUBLIC_URL}/img/${this.props.videoCover}`}
            />
          </div>
          <div className="m-grid-10 grid-wrapper">
            <div ref="content" className="content">
              <p dangerouslySetInnerHTML={{ __html: this.props.content }} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/World/mobile/columnVideo/index.js